import React, { Component } from "react";
import { useParams, Link } from "react-router-dom";
import BookCard from "../componentes/BookCard";

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

class FilterBy extends Component {
  state = {
    books: [],
    error: null,
    isLoading: false,
  };

  componentDidMount() {
    this.fetchBooks();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.params.idTipo !== prevProps.params.idTipo ||
      this.props.params.idNombre !== prevProps.params.idNombre
    ) {
      this.fetchBooks();
    }
  }

  fetchBooks = async () => {
    this.setState({ isLoading: true, books: [] });
    const { idTipo, idNombre } = this.props.params;
    let url = "https://gutendex.com/books/";

    switch (idTipo) {
      case "Authors":
        url += `?search=${idNombre}`;
        break;
      case "Subjects":
      case "Bookshelves":
        url += `?topic=${idNombre}`;
        break;
      case "Languages":
        url += `?languages=${idNombre}`;
        break;
      default:
        this.setState({ error: "Tipo de filtro no válido", isLoading: false });
        return;
    }

    try {
      const response = await fetch(url);
      const data = await response.json();
      this.setState({ books: data.results, isLoading: false });
    } catch (error) {
      console.error("Failed to fetch books:", error);
      this.setState({ error: "Failed to fetch books", isLoading: false });
    }
  };

  render() {
    const { books, error, isLoading } = this.state;
    const { idTipo, idNombre } = this.props.params;
    return (
      <main className="infoResult" role="main" aria-labelledby="filter-books">
        <h1 id="filter-title">
          Showing results for {idTipo}: {idNombre}
        </h1>
        {error && <p>Error: {error}</p>}
        <section aria-live="polite">
          {isLoading ? (
            <p>Loading...</p>
          ) : books.length > 0 ? (
            books.map((book) => <BookCard key={book.id} book={book} />)
          ) : (
            <p>No books found.</p>
          )}
        </section>
        <Link
          to="/books"
          className="explore-more-link"
          aria-label="Explore more books"
        >
          <button>Explore more books!</button>
        </Link>
      </main>
    );
  }
}

export default withParams(FilterBy);
